import { render } from "./TotalPriceEn.vue?vue&type=template&id=52043462&scoped=true"
import script from "./TotalPriceEn.vue?vue&type=script&lang=js"
export * from "./TotalPriceEn.vue?vue&type=script&lang=js"

import "./TotalPriceEn.vue?vue&type=style&index=0&id=52043462&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52043462"]])

export default __exports__